module.exports = __webpack_public_path__ + "img/tab2.eb92e37d.png";